import React from 'react';
import MarkdownToJsx from 'markdown-to-jsx';

const heading = (className: string) => {
	const Heading: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
		<p className={className}>
			<strong>{children}</strong>
		</p>
	);
	return Heading;
};

const overrides = {
	h1: heading('zi-md-heading zi-md-h1'),
	h2: heading('zi-md-heading zi-md-h2'),
	h3: heading('zi-md-heading zi-md-h3'),
	h4: heading('zi-md-heading'),
	h5: heading('zi-md-heading'),
	h6: heading('zi-md-heading'),
};

const Markdown: React.FC<{ children: string }> = ({ children }) => (
	<MarkdownToJsx options={{ overrides }}>{children}</MarkdownToJsx>
);

export default Markdown;
